// /src/services/firebase.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBx-T0tuEcSlSFsPF1zyeYQo3pZG-zytz8",
  authDomain: "clotere-33ee1.firebaseapp.com",
  projectId: "clotere-33ee1",
  storageBucket: "clotere-33ee1.appspot.com",
  messagingSenderId: "488961682641",
  appId: "1:488961682641:web:b89810aa37cda07d7169f0"
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();
const storage = getStorage(app);
const auth = getAuth(app);

export { app, storage, auth };